import React from 'react';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import ControlButton from '../ControlButton/ControlButton';
import type { Controls } from '../../../useControls';

const ExtentsControl = ({ controls }: { controls: Controls }) => (
	<ControlButton
		actions={[
			{
				id: 'fit-extents',
				label: 'Fit to extents',
				icon: <ZoomOutMapIcon />,
				onClick: () => controls.fitToExtent(),
				dataCy: 'fit-to-extents',
			},
		]}
	/>
);

export default ExtentsControl;
